import { SIGNZY_FAIL_STATUS_CODE } from './DetectSignzyFailure';

export const checkForSignzyFailure = (errorData: { status: number, statusCode?: string }): Record<'isSignzyFail', boolean> => {
    if (errorData.status === 503 && errorData.statusCode === SIGNZY_FAIL_STATUS_CODE) {
        window.postMessage(SIGNZY_FAIL_STATUS_CODE);
        return { isSignzyFail: true }
    }
    return { isSignzyFail: false };
}
